import PropTypes from 'prop-types';

import { PROGRESS_TYPES } from 'app/viewport/utils/constants';
import {
  DELIVERED_STATUS,
  NEW_STATUS,
  READ_STATUS,
} from 'app/viewport/utils/notification';

const NotificationShape = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
  hasBadge: PropTypes.bool,
  iconType: PropTypes.string,
  buttonText: PropTypes.string,
  link: PropTypes.string,
  buttonHandler: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  notificationStatus: PropTypes.oneOf([
    NEW_STATUS,
    DELIVERED_STATUS,
    READ_STATUS,
  ]).isRequired,
  badgeKind: PropTypes.oneOf(['new'].concat(Object.keys(PROGRESS_TYPES))),
  isImportant: PropTypes.bool,
  progressMax: PropTypes.number,
  progressValue: PropTypes.number,
  hasButton: PropTypes.bool,
  isDismissable: PropTypes.bool,
};

export default NotificationShape;
